import type {
  AccountBalance,
  AccountBalancesResponse,
} from '../types/trade';

export function toDisplayAccountBalances(response: AccountBalancesResponse): AccountBalance[] {
  return response.accounts.map((account) => ({
    account: account.account,
    fco: account.fco_total,
    usdt: account.usdt_total,
    totalUsd: account.total_usd,
    lastUpdated: account.lastUpdated ?? response.last_updated ?? '',
  }));
}
